import React from "react";
import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

export const MaskLine = ({ children, delay = 0, className = "", load = false }) => {
  const anim = load
    ? { initial: { y: "110%" }, animate: { y: "0%" } }
    : { initial: { y: "110%" }, whileInView: { y: "0%" }, viewport: { once: true, margin: "-10%" } };
  return (
    <span className="reveal-mask">
      <motion.span
        className={`block ${className}`}
        {...anim}
        transition={{ duration: 1, ease: EASE, delay }}
      >
        {children}
      </motion.span>
    </span>
  );
};

export const FadeUp = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-8%" }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export { EASE };
